import { Box, ModalHeader, Typo } from '@wrisk/ui-components'
import i18n from 'i18next'
import React, { FunctionComponent } from 'react'

import { CustomerCheckResults, CustomerCheckResultType } from '../../../../../../domain'
import {
  TKey,
  useWriskTranslation,
} from '../../../../../../infrastructure/internationalisation'
import { WriskTrans } from '../../../../../organisms/trans'

const tKey = TKey('components.verification-failed-modal')

export interface VerificationFailedModalProps {
  checks: CustomerCheckResults
}

export const VerificationFailedModal: FunctionComponent<VerificationFailedModalProps> = ({
  checks,
}) => {
  const { t } = useWriskTranslation()

  // first failure with translation
  const failure = Object.entries(checks)
    .filter(([, value]) => value.result === CustomerCheckResultType.CONSIDER)
    .map(([key]) => key)
    .find((key) => i18n.exists(tKey('messages', key)))

  const header = t([
    tKey('messages', failure, 'header'),
    tKey('messages', 'default', 'header'),
  ])

  const message = (
    <WriskTrans
      t={t}
      i18nKey={[
        tKey('messages', failure, 'content'),
        tKey('messages', 'default', 'content'),
      ]}
    />
  )

  return (
    <Box>
      <ModalHeader header={header} />
      <Typo>{message}</Typo>
    </Box>
  )
}
